import styled, { keyframes } from 'styled-components';

export const _PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  max-width: 100em;
  min-height: 300px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
`;

export const _TwoColumnLayout = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;

    section + section {
      margin-left: 60px;
    }
  }

  img {
    max-inline-size: 100%;
    block-size: auto;
  }
`;

export const _FormNotFoundContainer = styled.div`
  padding: 0 20vw;
  text-align: center;
`;

export const _FormElementWrapper = styled.div`
  margin-bottom: ${(props) => (props.isLast ? '0px' : '30px')};
`;

const slideIn = keyframes`
  from { bottom: -100px; }
  to { bottom: 20px; }
`;

const slideOut = keyframes`
from { bottom: 20px; }
to { bottom: -100px; }
`;

export const _ErrorMsg = styled.div`
  z-index: 10;
  display: inline-block;
  visibility: ${(props) => (props.show ? 'visible' : 'hidden')};
  animation: ${(props) => (props.show ? slideIn : slideOut)} 0.5s linear;
  bottom: ${(props) => (props.show ? '20px' : '-100px')};
  transition: visibility 0.5s linear;

  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  font-weight: 600;
  display: flex;
  align-items: flex-start;

  background-color: #a5432f;
  color: white;
  position: fixed;

  span {
    padding: 20px;
  }
  button {
    border: 0;
    background: 0;
    color: white;
    cursor: pointer;
    font-size: 20px;
  }
`;
